import { IApplicationState } from '../../types/redux';

export function selectOfferChatIsDotPin(state: IApplicationState): boolean | undefined {
  return state.chatModal.isDotPin;
}
